import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Address,
  Phone,
  Name,
  Email,
} from 'ecs-react-components/dist/index.es';

import { careProviderSelected } from '../../redux/modules/secure-message/actions/creators';
import { messages } from './CareTeamMemberCard.i18n';
import SecureMessageForm from '../../containers/SecureMessage/SecureMessageForm';

class CareTeamMemberCard extends React.Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
    };
  }

  onSendButtonClick = () => {
    this.props.dispatch(careProviderSelected(this.props.careTeamMember.careProviderId));
    this.setState({ showModal: true });
  };

  getPersonName() {
    return {
      firstName: this.props.careTeamMember.firstName,
      lastName: this.props.careTeamMember.lastName,
      suffix: this.props.careTeamMember.suffix,
      title: this.props.careTeamMember.careProviderTitle };
  }

  closeModal = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  renderContactInfoSubset = () => {
    const { careTeamMember } = this.props;
    return (
      <div className="row">
          {this.renderPhoto()}
      <div className="col">
          <div className="contact-info">
            <strong><Name name={this.getPersonName()} otherProperties={{ tabIndex: 0 }} /></strong>&nbsp;
            <Address
              address={
                {
                  address1: careTeamMember.address1,
                  address2: careTeamMember.address2,
                }
              }
              otherProperties={{ tabIndex: 0 }}
            />
            <Email email={careTeamMember.publicEmail} otherProperties={{ tabIndex: 0 }} />
            <Phone
              phone={ careTeamMember.publicPhone }
              fax={ careTeamMember.fax }
              otherProperties={{ tabIndex: 0 }}
            />
          </div>
      </div>
      </div>
    );
  }

  /* eslint jsx-a11y/img-redundant-alt:0 */
  renderPhoto() {
    if (this.props.careTeamMember.userProfileImageUrl) {
      return (
        <div className="col">
            <div className="user-image">
              <img className="img-responsive" alt="no image"
                src={ this.props.careTeamMember.userProfileImageUrl }
              />
            </div>
        </div>);
    }
    return null;
  }

  renderSecureMessageButton() {
    if (this.props.careTeamMember.preferredSecureMessageIfSystemId &&
        this.props.careTeamMember.secureMessageRecipientForPatient &&
        this.props.capabilities.some((x) => x.moduleName === 'SecureMessages')) {
      return (
        <div className="card-footer">
        <Button onClick={this.onSendButtonClick}
          className="btn-sm float-right" role="link" variant="link"
        >
          <span className="fa fa-envelope" aria-hidden="true">
          </span>
          <FormattedMessage {...messages.securemessage} />
        </Button>
        </div>);
    }

    return null;
  }

  render() {
    return (
        <div className="card h-100 contact-card notheme">
          <div className="card-body">
              {this.renderContactInfoSubset()}
              <SecureMessageForm showModal={ this.state.showModal } close={ this.closeModal } />
          </div>
          {this.renderSecureMessageButton()}
        </div>
    );
  }
}

CareTeamMemberCard.propTypes = {
  careTeamMember: PropTypes.object.isRequired,
  displayPhoto: PropTypes.bool,
  dispatch: PropTypes.func,
  intl: PropTypes.object,
  windowSize: PropTypes.string,
  capabilities: PropTypes.array,
};

CareTeamMemberCard.defaultProps = {
  displayPhoto: true,
};

const mapStateToProps = (state) => ({
  capabilities: state.capability.capabilities,
});
export default connect(mapStateToProps)(injectIntl(CareTeamMemberCard));